import { useTeamMemberEntityHistoryTimeline } from '../../../../core/queries/entity-history.queries';

export function useTeamMemberEntityHistory(accountID: string | undefined) {
  return useTeamMemberEntityHistoryTimeline(accountID ?? '');
}
